// extracted by mini-css-extract-plugin
var _1 = "#ddd";
var _2 = "#ccc";
var _3 = "#4da8d3";
var _4 = "#4da8d3";
var _5 = "#4da8d3";
export { _1 as "colorBorder", _2 as "colorBorderSecondary", _3 as "colorInfo", _4 as "colorLink", _5 as "colorPrimary" }
